import Image from '@tiptap/extension-image';

/**
 * Lesson images are private: `src` shows a signed url that expires, so it can never be what we store.
 * This carries the stable S3 path alongside it in `data-path`, and `serializeToStorage` rewrites the
 * html so `src` holds the path — the exact contract the backend sanitizer enforces on the way in.
 */
export const LessonImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-path': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-path'),
        renderHTML: (attributes) => (attributes['data-path'] ? { 'data-path': attributes['data-path'] } : {}),
      },
    };
  },
});

/**
 * Swaps every image's signed `src` for its `data-path` before the html is sent to the server, so
 * nothing expiring is ever persisted. Runs on a detached DOM tree, never on the live document.
 */
export const serializeLessonHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('img').forEach((img) => {
    const path = img.getAttribute('data-path');
    if (path) {
      img.setAttribute('src', path);
      img.removeAttribute('data-path');
    }
  });
  return doc.body.innerHTML;
};
